
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class StepCard extends Vue {
  @Prop({ required: true, type: String }) step!: string;
  @Prop({ required: true, type: String }) title!: string;
  @Prop({ required: true, type: Number }) status!: number; // 0: pending, 1: complete, 2: special case
  @Prop({ required: true, type: String }) statusText!: string;
  @Prop({ required: false, type: String }) icon!: string;
  @Prop({ default: false, type: Boolean }) canModify!: boolean;
  @Prop({ default: '', type: String }) modifyLink!: string;
  @Prop({ default: 'Modificar', type: String }) modifyText!: string;
  @Prop({ default: false, type: Boolean }) isGratuity!: boolean; // Nueva prop

  get displayStatusText(): string {
    // Si es gratuidad y el estado original es "pendiente", cambiar el texto
    if (this.isGratuity && this.status === 0) {
      return 'Completo - Gratuidad';
    }
    return this.statusText;
  }

  get statusClasses(): string {
    // Si es gratuidad, usar clases de éxito
    if (this.isGratuity && this.status === 0) {
      return 'bg-gradient-to-r from-verde-institucional to-green-500 text-white';
    }

    // Estados normales
    switch (this.status) {
      case 1:
        return 'bg-gradient-to-r from-verde-institucional to-green-500 text-white';
      case 0:
        return 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white';
      default:
        return 'bg-gradient-to-r from-gray-400 to-gray-500 text-white';
    }
  }

  get statusIcon(): string {
    // Si es gratuidad, usar icono de check
    if (this.isGratuity && this.status === 0) {
      return 'fas fa-check-circle';
    }

    // Iconos normales
    switch (this.status) {
      case 1:
        return 'fas fa-check-circle';
      case 0:
        return 'fas fa-clock';
      default:
        return 'fas fa-info-circle';
    }
  }

  navigateToModify(): void {
    if (this.modifyLink) {
      this.$router.push({ name: this.modifyLink });
    }
  }
}
